<div class="modal-header">
    <h5 class="modal-title">Sign in to student site</h5>
    <button
        type="button"
        class="close"
        data-dismiss="modal"
        aria-label="Close"
        (click)="activeModal.dismiss('Cross click')"
    >
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <!-- Region: Auth Step One -->
    <div *ngIf="studentLogin.shouldDisplayUsernameInput()">
        <div class="student-login-form">
            <p>Access your assignments, projects, and favorites.</p>
        </div>
        <div class="username-input">
            <app-input-box
                label="Username"
                [(inputModel)]="studentUsername"
                (click)="
                    studentLogin.isLoginInitiated = false;
                    studentLogin.restoreInitialSecretQuestionValue()
                "
                (keydown.enter)="
                    studentLogin.initiateLogin(studentUsername);
                    studentLogin.isLoginInitiated = true
                "
            >
            </app-input-box>
            <app-button
                (click)="
                    studentLogin.initiateLogin(studentUsername);
                    studentLogin.isLoginInitiated = true
                "
                >Next
            </app-button>
        </div>
        <app-error-message
            *ngIf="studentLogin.getSecretQuestion() == null && studentLogin.isLoginInitiated"
            errorMessage="This username does not exist."
        >
        </app-error-message>
    </div>
    <!-- /Region: Auth Step One -->
    <!-- Region: Auth Step Two -->
    <div *ngIf="studentLogin.shouldDisplayQuestionInput()">
        <div class="student-login-form">
            <p>
                <span>Answer your secret question to finish log in</span><br />
                <span>{{ studentLogin.getSecretQuestion() }}</span>
            </p>
        </div>
        <div class="secret-answer-input">
            <app-input-box
                label="{{ studentLogin.generateLabelFromSecretQuestion() }}"
                [(inputModel)]="secretAnswer"
                (click)="
                    studentLogin.isLoginValidationInitiated = false;
                    studentLogin.restoreInitialLoginEvaluationValue()
                "
                (keydown.enter)="
                    studentLogin.validateLogin(secretAnswer);
                    studentLogin.isLoginValidationInitiated = true
                "
            >
            </app-input-box>
            <app-button
                (click)="
                    studentLogin.validateLogin(secretAnswer);
                    studentLogin.isLoginValidationInitiated = true
                "
            >
                Go</app-button
            >
        </div>
        <app-error-message
            *ngIf="
                studentLogin.getLoginValidity() === 'False' &&
                studentLogin.isLoginValidationInitiated
            "
            errorMessage="This answer does not match your original one. Please try again."
        >
        </app-error-message>
    </div>
    <!-- /Region: Auth Step Two -->
    <hr />
    <div class="google-auth-wrapper">
        <a
            [href]="userService.getGoogleAuthUrl(getStudentNext(), true)"
            class="selenium-continue-google"
        >
            <img class="auth-icon" [src]="googleImage" alt="Google Auth" />
            Continue as Google Classroom Student
        </a>
    </div>
    <div>
        <a class="sign-up" href="/student/signup/?next=/student/">
            I need to sign up!
            <app-icon [type]="'Arrow-right'"></app-icon>
        </a>
        <div class="teacher-callout">
            <span> Are you a teacher? </span>
            <a [routerLink]="['/']" (click)="activeModal.close()">
                Sign in on our teacher site
                <app-icon [type]="'Arrow-right'"></app-icon>
            </a>
        </div>
    </div>
</div>
